const moduleConstant = {
    EmailWebsite: 20,
    Kanban: 21,
    AssistantArtifact: 22,
    EnquiryCentre: 23,
    Object: 1,
    Person: 2,
    Demand: 3,
    Project: 4,
    Media: 5,
    Inventory: 6,
    Program: 7,
    Management: 8,
    Configs: 9,
    Company: 10,
    Lync: 11,
    Task: 12,
    History: 13,
    Agenda: 14,
    Dashboard: 15,
    Language: 16,
    PropertyEnvironment: 17,
    MyAccount: 18,
    AdvanceSearch: 19,
    NULL: 0
};

export default moduleConstant;
